import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "../client";

// Saves the org-wide letter print-layout settings (super_admin only on the backend).
// Invalidates the cached settings so open letters/preview pick up the new values.
const useLetterSettingsMutation = (onSuccess) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values) =>
      apiClient.patch("/admin/letter-settings", values).then((res) => res.data?.data),
    onSuccess: (data, vars, ctx) => {
      queryClient.invalidateQueries({ queryKey: ["letter-settings"] });
      if (onSuccess) onSuccess(data, vars, ctx);
    },
  });
};

export default useLetterSettingsMutation;
